import React from 'react';

export default function Footer({ dark }) {
  const year = new Date().getFullYear();

  if (dark) {
    return (
      <div style={{
        borderTop: '1px solid rgba(255,255,255,0.08)',
        padding: '20px 16px',
        textAlign: 'center',
        fontSize: '12px',
        color: 'rgba(255,255,255,0.3)',
      }}>
        &copy; {year} Live Pickle Ball &middot; Developed by Jay Patel
      </div>
    );
  }

  return (
    <footer className="app-footer">
      &copy; {year} Live Pickle Ball &middot; Developed by Jay Patel
    </footer>
  );
}
